import { AppError } from '../types';

export async function withRetry<T>(operation: () => Promise<T>, signal: AbortSignal, attempts = 3, onRetry?: (attempt: number) => void): Promise<T> {
  let last: unknown;
  for (let attempt = 1; attempt <= attempts; attempt += 1) {
    if (signal.aborted) throw new AppError('CANCELLED', 'Đã hủy tác vụ.');
    try { return await operation(); } catch (error) {
      last = error;
      if (!(error instanceof AppError) || !error.retryable || attempt === attempts) throw error;
      onRetry?.(attempt); const delay = Math.min(8000, 500 * 2 ** (attempt - 1)) + Math.random() * 250;
      await new Promise<void>((resolve, reject) => { const id = window.setTimeout(resolve, delay); signal.addEventListener('abort', () => { window.clearTimeout(id); reject(new AppError('CANCELLED', 'Đã hủy tác vụ.')); }, { once: true }); });
    }
  }
  throw last;
}
